import Headroom from 'headroom.js';

document.addEventListener("DOMContentLoaded", () => {
  let menuToggles = document.querySelectorAll('.header__toggle');
  if (menuToggles) {
    menuToggles.forEach((menuToggle) => {
      menuToggle.addEventListener('click', (event) => {
        document.querySelector('body').classList.toggle('menu-is-active');
        document.querySelector('#header__menu').classList.toggle('header__menu--active');
        event.preventDefault();
      });
    });
  }

  let header = document.querySelector('.menu');
  if (header) {
    let headroom  = new Headroom(header, {
      classes: {
        initial: 'menu',
        pinned: 'menu--pinned',
        unpinned: 'menu--unpinned',
        top: 'menu--top',
        notTop: 'menu--not-top',
        bottom: 'menu--bottom',
        notBottom: 'menu--not-bottom',
        frozen: 'menu--frozen',
      },
    });
    headroom.init();
  }
});
